<template>
    <div class="mobile-parking-links">
        <el-dialog :visible.sync="dialogVisible" :show-close="false" top="50vh" :append-to-body="true" custom-class="mobile-parking-links__dialog">
            <div class="mobile-parking-links__content">
                <div class="mobile-parking-links__head">
                    <div class="copy-light-small">
                        Parkschein buchen
                    </div>
                    <div class="mobile-parking-links__close" @click="closeClickHandler">
                        <icon><IconClose/></icon>
                    </div>
                </div>
                <div class="mobile-parking-links__list">
                    <div class="mobile-parking-links__item" v-for="(link, index) in mobileParkingLinks" :key="index">
                        <component :is="link.link ? 'a' : 'div'" :href="link.link ? link.link : ''" target="_blank" class="mobile-parking-links__item__link copy">
                            {{ link.title }}
                        </component>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from '@/components/Icon.vue'
import IconClose from '@/components/icons/IconClose.vue'
import eventBus from '@/utils/event-bus';
import { getPaymentOptionLabel } from '@/utils/poi-detail-labels'

export default {
    components: {
        Icon,
        IconClose
    },
    data() {
        return {
            dialogVisible: false,
            availableOptions: false,
        }
    },
    computed: {
        ...mapGetters(['deviceSystem']),
        mobileParkingLinks() {
            if(!this.availableOptions) return []
            const links = []
            this.availableOptions.forEach(option => {
                let link = false
                if(this.deviceSystem) {
                    switch(this.deviceSystem) {
                        case ('android'):
                            link = option.urls[3] ? option.urls[3] : false
                            break;
                        case ('ios'):
                            link = option.urls[1] ? option.urls[1] : false
                            break;
                    }
                }
                const title = getPaymentOptionLabel(option.type)
                if(link) {
                    links.push({
                        title: title,
                        link: link,
                    })
                }
            });

            return links
        }
    },
    mounted() {
        this.addListeners()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        closeClickHandler() {
            this.closeDialog();
        },
        showMobileParkingLinksHandler(e) {
            if(e && e.length) {
                this.availableOptions = e
                this.showDialog()
            }
        },
        addListeners() {
            eventBus.$on('showMobileParkingLinks', this.showMobileParkingLinksHandler);
        },
        removeListeners() {
            eventBus.$off('showMobileParkingLinks', this.showMobileParkingLinksHandler);
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        showDialog() {
            this.dialogVisible = true;
        },
    }
}
</script>

<style lang="scss">
.mobile-parking-links {
    &__dialog {
        border-radius: $standard-border-radius;
        max-width: 500px;
        width: calc(100% - 32px);
        transform: translateY(-25%);

        .el-dialog {
            &__header {
                display: none;
            }
            &__body {
                position: relative;
                padding: 0;
            }
        }
    }

    &__content {
        padding: 0 16px;
        overflow: auto;
    }

    &__head {
        position: relative;
        border-bottom: 1px solid $color-black-005;
        padding: 14px 0 12px;
    }

    &__close {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        color: $color-grey;
        line-height: 0;
        transition: 0.2s;
        cursor: pointer;

        .no-touch &:hover {
            color: $color-black;
        }
    }

    &__item {
        padding: 12px 0; 

        &:not(:last-child) {
            border-bottom: 1px solid $color-black-005;
        }

        &__link {
            color: $color-black;
            text-decoration: none;
        }
    }
}
</style>